import { instance2 } from '../helper/api'

export const get = async param => {
  let paramValue = null
  if (param) {
    paramValue = JSON.parse(param)
  }

  let resultData = {}
  const axiosConfig = {
    url: '/v1/order/',
    method: 'GET',
    params: paramValue
  }

  try {
    const results = await instance2.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const cancel = async data => {
  let resultData = {}
  const axiosConfig = {
    url: `/v1/order/${data.order_id}/`,
    method: 'PATCH',
    data: {
      order_status: 'CANCELED'
    }
  }

  try {
    const results = await instance2.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const getAllOrders = async params => {
  let resultData = {}
  let url = '/v1/order/'
  if (['ON DELIVERY', 'COMPLETED'].includes(params.status)) {
    url = '/v1/order/delivery/detail/'
  }
  const axiosConfig = {
    url,
    method: 'GET',
    params
  }

  try {
    const results = await instance2.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const orderApproval = async data => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/order/approval/',
    method: 'POST',
    data
  }

  try {
    const results = await instance2.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}

export const orderStatusCount = async () => {
  let resultData = {}
  const axiosConfig = {
    url: '/v1/order/status-count/',
    method: 'GET'
  }

  try {
    const results = await instance2.request(axiosConfig)
    resultData = results.data
  } catch (error) {
    if (error.response) {
      return error.response.data
    } else {
      return error.message
    }
  }

  return resultData
}
